<template>
  <div class="h-full" v-loading="shareLoading">
    <TableContent :page="PAGE_TYPE.COOPERATION" v-if="showContent" />
  </div>
</template>

<script>
import { getDetailByShareLinkUrl, addShareCoords, checkSharedSelf } from '@/api/wenjuan/wjquestion'
import TableContent from './components/TableContent.vue'
import { PAGE_TYPE } from './variable'
import { getSurveyDomain } from '@/assets/js/config/env'

export default {
  name: 'Cooperation',
  components: { TableContent },
  data() {
    return {
      PAGE_TYPE,
      shareLoading: false,
      shareSuccess: false
    }
  },
  computed: {
    showContent() {
      const isCooper = this.$route.path.includes('/project/cooperation')
      const { from } = this.$route.query || {}
      if (isCooper && from === 'linkShare') {
        return this.shareSuccess
      }
      return true
    }
  },
  mounted() {
    this.setAddLinkByFromShare()
  },
  methods: {
    async setAddLinkByFromShare() {
      const { from, createId, questionId } = this.$route.query || {}
      const isShare = from === 'linkShare'
      if (isShare) {
        const query = `?from=linkShare&createId=${createId ?? ''}&questionId=${questionId ?? ''}`
        const queryUrl = `${getSurveyDomain()}/entrance/#/project/cooperation${query}`
        // 校验是否自己分享给自己
        this.shareLoading = true
        try {
          const res = await checkSharedSelf(queryUrl)
          const { code, msg, data } = res.data || {}
          if (code === 0) {
            if (typeof data === 'boolean') {
              // data是Boolean值 true:分享给自己 false:分享给别人
              if (data) {
                this.$message.warning('问卷不能分享给自己')
                this.shareSuccess = true
                this.shareLoading = false
                return
              }
            } else {
              this.$message.error('验证是否分享自己失败')
              this.shareSuccess = true
              this.shareLoading = false
              return
            }
          } else {
            this.$message.error(msg ?? '验证是否分享自己失败')
            this.shareSuccess = true
            this.shareLoading = false
            return
          }
        } catch (e) {
          this.$message.error('验证是否分享自己失败')
          this.shareSuccess = true
          this.shareLoading = false
          return
        }
        let shareDetail = null
        try {
          const res = await getDetailByShareLinkUrl(queryUrl)
          const { code, msg, data } = res.data || {}
          if (code === 0) {
            shareDetail = data
          } else {
            this.$message.error(msg ?? '根据分享链接url获取权限数据失败')
            this.shareSuccess = true
            this.shareLoading = false
            return
          }
        } catch (e) {
          this.$message.error('根据分享链接url获取权限数据失败')
          this.shareSuccess = true
          this.shareLoading = false
          return
        }
        if (!shareDetail) {
          this.shareSuccess = true
          this.shareLoading = false
          return
        }
        if (shareDetail.openShare) {
          try {
            const {
              openShare,
              shortUrl,
              wjId,
              tenantId,
              isExamineControl,
              isLogicWxRed,
              isNetworkAgent,
              isSeeEdit,
              isStatistics,
              sharedBy,
              shareReport
            } = shareDetail
            const { baseId, phone, username } = this.$store.getters?.userInfo || {}
            const req = {
              channel: 3,
              flag: 1,
              baseIds: [baseId ?? ''],
              wjId,
              tenantId,
              openShared: openShare,
              linkCode: shortUrl,
              sharedByUserId: sharedBy,
              phoneAndNameList: [{ phone: phone ?? '', name: username ?? '' }],
              isExamineAndRecyclingProcessAndQcontrol: isExamineControl,
              isExpenseSettlement: true,
              isLogicAndPersonAndPageAndWxRed: isLogicWxRed,
              isNetworkSurveyAndFaceVisitAndPrincipalAgent: isNetworkAgent,
              isSeeAndEdit: isSeeEdit,
              isStatisticsAndAnalysisAnswerData: isStatistics,
              shareReport
            }
            const res = await addShareCoords(req)
            const { code, msg, data } = res.data || {}
            if (code === 0) {
              this.$message.success('保存分享链接成功')
              this.$router.replace({ name: 'cooperation' })
            } else {
              this.$message.error(msg ?? '保存分享链接失败')
            }
          } catch (e) {
            this.$message.error('保存分享链接失败')
          } finally {
            this.shareSuccess = true
            this.shareLoading = false
          }
        } else {
          this.$message.warning('链接已失效')
          this.shareSuccess = true
          this.shareLoading = false
        }
      } else {
        this.shareSuccess = true
      }
    }
  }
}
</script>
